import React, { useEffect, useState, useRef } from 'react'

import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid';
import FuseLoading from '@fuse/core/FuseLoading/FuseLoading';
import { withRouter } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { AgGridReact } from 'ag-grid-react';
import '../../../../../../styles/ag-custom.css';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';

import axios from "@fuse/utils/axios";
import { duration } from 'moment';
import Status from '../Status';
import { getLocalTimeFromUTC } from '@fuse/utils/dateOperations';

const useStyles = makeStyles({

    root: {
        // '& .MuiDataGrid-root-1911 .MuiDataGrid-footer':{
        //   border: '2px solid black',
        //   display: 'none !important'
        // }
        '& .MuiDataGrid-columnsContainer': {
            background: '#8f8f8f26'
        }
    }
});


function IncidentsTab(props) {
    const classes = useStyles();
    const tableHeaders = [
        {
            field: "severity",
            headerName: "Severity",
            headerComponent: (props) => (CustomFilter(props, header, gridRef)),
            minWidth: 150
        },
        {
            field: "time",
            headerName: "Event Date & Time",
            minWidth: 260,
            headerComponent: CustomFilter
        },
        {
            field: "problem",
            headerName: "Description",
            minWidth: 350,
            maxWidth: 350,
            headerComponent: CustomFilter
        },
        {
            field: "recovery_time",
            headerName: "Recovery Time",
            minWidth: 150,
            headerComponent: CustomFilter
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 150,
            headerComponent: CustomFilter
        },
        {
            field: "duration",
            headerName: "Duration",
            // cellRenderer: AssetActionComponent,
            minWidth: 140,
            maxWidth: 140
        }
    ];

    const gridRef = useRef()

    const onGridReady = params => {
        // Following line to make the currently visible columns fit the screen  
        params.api.sizeColumnsToFit();

        // Following line dymanic set height to row on content
        params.api.resetRowHeights();
    };
    const [rowData, setRowData] = useState([]);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight - 430);

    const [loading, setLoading] = useState(false)

    const { assetDetails } = props

    function formtIncidents(incidents) {
        return incidents.map((item) => {
            return {
                id: item.id,
                // ticket_number: '27927',
                severity: item.event_severity,
                time: getLocalTimeFromUTC(item.created_at),
                recovery_time: item.recovery_time,
                status: item.event_status,
                problem: item.alert_subject,
                duration: item.event_duration
            }
        })
    }
    function getIncidents() {
        if (!assetDetails) return
        setLoading(true)
        axios.get(`/assets/fetch-asset-incident/${assetDetails.id}`, {
        }).then((res) => {
            const { incident } = res.data.data;
            setRowData(formtIncidents(incident))
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        getIncidents()
    }, [])

    if (loading) {
        return (
            <FuseLoading />
        )
    }

    return (
        <>
            {rowData.length === 0 &&
                <div className='no_data_holder'>
                    <img src='assets/images/nodata.svg' alt='icon' />
                    <p className='bold_txt'>It's all empty here!</p>
                    <p className='normal_txt'>No data to show yet</p>
                </div>
            }

            {
                rowData.length > 0 &&
                <div
                    className="ag-theme-alpine"
                    style={{
                        width: "100%",
                        height: windowHeight + 105,
                        fontSize: '12px'
                    }}
                >
                    <AgGridReact
                            ref={gridRef}
                            theme='legacy'
                        rowData={rowData}
                        animateRows
                        onGridReady={onGridReady}
                        paginationPageSize={10}
                            paginationPageSizeSelector={[10, 20, 50, 100]}
                        pagination
                        defaultColDef={{
                            resizable: true,
                            flex: 1,
                            sortable: false,
                            filter: 'agTextColumnFilter',
                            wrapText: true,
                        }}
                        columnDefs={tableHeaders.map(header => ({
                            field: header.field,
                            headerName: header.headerName,
                            width: header.width,
                            minWidth: header.minWidth,
                            maxWidth: header.maxWidth,
                            autoHeight: header.field === 'problem',
                            cellRenderer: header.field === 'status'
                                ? (params) => {
                                    const isResolved = params.value?.toLowerCase() === 'resolved';
                                    const bgColor = isResolved ? '#f2ffeb' : '#FFFAEB';
                                    const textColor = isResolved ? '#4bf709' : '#F79009';
                                    const borderColor = isResolved ? '#4bfe59' : '#FEC84B';
                                    return `<span style="
                      background-color:${bgColor};
                      color:${textColor};
                      font-size:12px;
                      font-weight:500;
                      border:1px solid ${borderColor};
                      border-radius:16px;
                      padding:2px 16px;
                    ">${params.value.charAt(0).toUpperCase() + params.value.slice(1).toLowerCase()}</span>`;
                                }
                                : undefined,
                            headerComponent: (props) => CustomFilter(props, header, gridRef)
                        }))}
                    />
                </div>
            }
        </>
    )

    // return (
    //     <>
    //         <div className={classes.root} style={{ height: 290, width: '100%', overflow: "auto" }}>
    //             <DataGrid
    //                 rows={incidents}
    //                 columns={columns}
    //                 hideFooter
    //             />
    //         </div>
    //     </>
    // )
}

export default withRouter(IncidentsTab)
